import { Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colorTokens, radiusTokens } from '../../app/designTokens';
import { RegisterSectionCard } from './RegisterSectionCard';
import { REGISTER_LABEL_SX, REGISTER_VALUE_SX } from './registerSurfaces';

const { semantic } = colorTokens;

/**
 * Steps 5–6 modules card. The public launch status endpoint does not expose the
 * ordered modules, so the values come from the launch snapshot stored in this
 * browser session at submit time. Without it the card degrades to a notice.
 */
export function LaunchModulesCard({ context, activated = false, testId = 'register-launch-modules' }) {
  const { t } = useTranslation(['onboarding', 'pricing', 'register', 'common']);
  const modules = context?.modules || [];

  return (
    <RegisterSectionCard
      title={activated
        ? t('onboarding:register.wizard.activated_modules')
        : t('onboarding:register.wizard.provisioning_modules')}
      testId={testId}
    >
      {modules.length === 0 ? (
        <Typography sx={{ fontSize: 13, color: semantic.text.muted }}>
          {t('onboarding:register.wizard.modules_unavailable')}
        </Typography>
      ) : (
        <Stack spacing={1.25}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {modules.map((code) => (
              <Chip
                key={code}
                size="small"
                label={code}
                data-testid={`register-launch-module-${code}`}
                sx={{
                  borderRadius: `${radiusTokens.chip}px`,
                  bgcolor: semantic.status.brand.bg,
                  color: semantic.status.brand.text,
                  border: `1px solid ${semantic.status.brand.border}`,
                }}
              />
            ))}
          </Stack>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Typography sx={REGISTER_LABEL_SX}>
              {t('pricing:pricing_preview.billing_interval')}
            </Typography>
            <Typography sx={REGISTER_VALUE_SX}>
              {context.billingInterval === 'yearly'
                ? t('pricing:pricing_preview.interval_yearly')
                : t('pricing:pricing_preview.interval_monthly')}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <Typography sx={REGISTER_LABEL_SX}>{t('pricing:register.users_count')}</Typography>
            <Typography sx={REGISTER_VALUE_SX}>{context.usersCount}</Typography>
          </Stack>
          {context.smsNotificationsEnabled ? (
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography sx={REGISTER_LABEL_SX}>{t('register:smsNotifications')}</Typography>
              <Typography sx={REGISTER_VALUE_SX}>{t('register:smsUsageBased')}</Typography>
            </Stack>
          ) : null}
        </Stack>
      )}
    </RegisterSectionCard>
  );
}

export default LaunchModulesCard;
